import React, { Component } from 'react';
import { size, isEmpty } from "lodash";
import { ListLayout } from '../containers/Layout';

import { TableRow, TableCell, Button, Grid, TableHead, TableBody, IconButton } from '@material-ui/core';
import { AddRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';

class ListInstallItem extends Component {
    state = { }

    componentDidMount = () => {
        console.log("MOUNTING ListInstallItems ");
    }

    createInstallList = (list) => {
        const { INSTALLS, SHOPS, CLIENTS, PRODUCTS, rowsPerPage, currentPageProd } = this.props

        return list.slice(currentPageProd * rowsPerPage, currentPageProd * rowsPerPage + rowsPerPage).map(installItem => {

            let client = CLIENTS[installItem.sale_item_client_id]
            let shop = SHOPS[installItem.sale_item_shop]
            let product = PRODUCTS[installItem.product_id]
            let install = INSTALLS[installItem.sale_id]
            return (
                <TableRow key={installItem.id} >
                    <TableCell>{(new Date(installItem.sale_item_date)).toLocaleString('fr-FR')}</TableCell>
                    <TableCell>{product.name} - {product.marque}</TableCell>
                    <TableCell>{installItem.quantity}</TableCell>
                    <TableCell>
                        {shop ? (
                            <a 
                                href="#" 
                                onClick={ () => this.props.handleSingleShop(shop) }
                            > 
                                {shop.name}
                            </a>
                        ) : (
                            <span>{installItem.sale_item_shop}</span>
                        )}
                    </TableCell>
                    <TableCell>
                        <IconButton 
                            color="secondary"
                            onClick={
                                () => this.props.handleSingleInstall(install, shop, client)
                            }
                        >
                            <AddRounded />
                        </IconButton>
                    </TableCell>
                </TableRow>
            )
        })        
    }  
    
    filterAll = () => {
        const { searchProduct } = this.props;

        let newList = this.props.getFilteredList()

        let itemList = []
        newList.forEach(install => 
            itemList.push(...install.products)
        )
        if( !isEmpty(searchProduct)){
            itemList = itemList.filter(item => this.props.prodFilter(item.product_id))
        }
        return itemList
    }

    displayList = () => {
        const { INSTALLS } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(INSTALLS)){
            let filteredList = this.filterAll()
            rows = size(filteredList)
            tab = this.createInstallList(filteredList)
        }
        return [tab, rows]
    }

    render() {
        let installList = this.displayList()

        return (
            <div>
                <ListLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                            <TableCell>Shop</TableCell>
                            <TableCell>Détails</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { installList[1] !== 0  && 
                            installList[0]
                        }
                        { installList[1] === 0  && 
                        <TableCell>
                            <TableCell colSpan={7}>
                                <div className="text-center">
                                    <h5>Pas encore de Installations</h5> 
                                    Cliquez sur <b className="onglet">"Nouveau"</b> Pour créer un nouvelle Installation
                                </div>
                            </TableCell>
                        </TableCell>
                        }
                    </TableBody>
                    { installList[1] > 20  && 
                        <TableFooterPagination 
                            colSpan={5}
                            // items={installList[0]} 
                            count={installList[1]}
                            onChangePage={this.props.onChangePage}
                            initialPage={this.props.currentPageProd || 0}
                            page={this.props.currentPageProd}
                        />         
                    }                              
                </ListLayout>
            </div>
        );
    }
}


export default ListInstallItem;